module.exports = __webpack_public_path__ + "static/media/info_crit.72b80302.svg";